import { FetchRegisterToB2b } from "./interface"

import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"

export class CompanyRegisterStorage {
    private static readonly storage = isStorageAvailable
        ? new StorageWrapper(window.localStorage)
        : undefined

    private static readonly STORAGE_KEY = "company_register_data"

    private static readonly MAX_AGE_MS = 5 * 60 * 1000

    private static getAllData(): {
        telephone?: string
        email?: string
        name?: string
        response?: FetchRegisterToB2b
        timestamp?: number
        resendTimeout?: number
    } {
        const data = this.storage?.getObject<{
            telephone?: string
            email?: string
            name?: string
            response?: FetchRegisterToB2b
            timestamp?: number
            resendTimeout?: number
        }>(this.STORAGE_KEY)

        return data || {}
    }

    static saveAllData(data: {
        telephone?: string
        email?: string
        name?: string
        response?: FetchRegisterToB2b
        timestamp?: number
        resendTimeout?: number
    }): void {
        const existingData = this.getAllData()
        const mergedData = { ...existingData, ...data }
        this.storage?.storeObject(this.STORAGE_KEY, mergedData)
    }

    private static isDataExpired(): boolean {
        const { timestamp } = this.getAllData()
        if (!timestamp) return true
        return new Date().getTime() - timestamp > this.MAX_AGE_MS
    }

    private static clearAllData(): void {
        this.storage?.remove(this.STORAGE_KEY)
    }

    static getTelephone(): string {
        if (this.isDataExpired()) {
            this.clearAllData()
            return ""
        }
        return this.getAllData().telephone || ""
    }

    static getEmail(): string {
        if (this.isDataExpired()) {
            this.clearAllData()
            return ""
        }
        return this.getAllData().email || ""
    }

    static getName(): string {
        if (this.isDataExpired()) {
            this.clearAllData()
            return ""
        }
        return this.getAllData().name || ""
    }

    static getResponse(): FetchRegisterToB2b | null {
        if (this.isDataExpired()) {
            this.clearAllData()
            return null
        }
        return this.getAllData().response || null
    }

    static getResendTimeout(): Date {
        const data = this.getAllData()
        if (!data.resendTimeout) {
            return new Date()
        }
        const timeoutDate = new Date(data.resendTimeout)
        return new Date().getTime() > timeoutDate.getTime() ? new Date() : timeoutDate
    }
}
